function isImage(filename) {
    return /\.(jpe?g|png|gif|bmp|svg|webp)$/i.test(filename);
}

// FileInput component
export default function (name) {
    let root, input, oldInput, preview;

    return {
        file: '',
        url: '',
        showPreview: false,
        basename: '',

        get name() {
            return name;
        },

        get basename() {
            return this.file.split('/').pop();
        },

        get loaded() {
            return this.file.length > 0;
        },

        get isImage() {
            return isImage(this.file);
        },

        init() {
            root = this.$root;
            ({ input, oldInput, preview } = this.$refs);

            Object.assign(this, Helper.parseElementDataset(root));

            oldInput.value = this.file;

            this.$watch('file', (value) => {
                if (value === '') {
                    this.url = '';
                    input.value = '';
                    preview.src = '';
                }

                oldInput.value = value;
            });

            this.$watch('url', (value) => (preview.src = value));

            const fileReader = new FileReader();
            fileReader.addEventListener('load', (event) => (preview.src = event.target.result));

            input.addEventListener('change', (event) => {
                if (event.target.files.length === 0) return;

                const file = event.target.files[0];
                this.file = file.name;
                this.url = '';

                if (!this.showPreview) return;

                if (!isImage(file.name)) {
                    preview.src = 'data:image/png;base64,';
                    return;
                }

                fileReader.readAsDataURL(file);
            });
        },

        select() {
            input.click();
        },

        remove() {
            this.resetData();
            input.dispatchEvent(new Event('change', { bubbles: true }));
            Helper.dispatchCustomEvent('revalidate', { attribute: name });
        },

        resetData(file = '', url = '') {
            const normalize = (value) => ([null, undefined].includes(value) ? '' : value);

            input.value = '';
            preview.src = preview.src.startsWith('data:image') ? '' : preview.src;
            this.file = normalize(file);
            this.url = normalize(url);
        },
    };
}
